import { Stack } from 'react-bootstrap';
import { ArrowLeftRight, ArrowRightCircleFill } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import LanguageFormSelect from './LanguageFormSelect';

import { isRtl } from '../util/RtlLanguageUtil';
import { useTranslationData } from '../TranslationContext';

const TranslateSelection = () => {

	const {
		languageFrom,
		languageTo,
		setLanguageFrom,
		setLanguageTo,
		setIsTextBeforeRtl,
		setIsTextAfterRtl,
		languages,
		isDetectLanguageLoading
	} = useTranslationData();

	const [swappable, setSwappable] = useState(false);
	const [languageFromLocaleId, setLanguageFromLocaleId] = useState<number | undefined>(undefined);
	const [languageToLocaleId, setLanguageToLocaleId] = useState<number | undefined>(undefined);
	const [isSourceLocaleLoading, setIsSourceLocaleLoading] = useState<boolean>(false);

	/**
	 * Update Language Select Field based on language detected and update swappable state based on changes from languageFrom languageTo fields
	 */
	useEffect(() => {
		const hasSelectedFromLanguage = languageFrom !== undefined && languageFrom !== '';
		const hasSelectedToLanguage = languageTo !== undefined && languageTo !== '';
		const isLanguageSwappable =
			hasSelectedFromLanguage && hasSelectedToLanguage && languageFrom !== languageTo;
		setSwappable(isLanguageSwappable);
		setIsSourceLocaleLoading(isDetectLanguageLoading);
	}, [languageFrom, languageTo, swappable, languages, isDetectLanguageLoading]);

	useEffect(() => {
		if (languageFrom) {
			const language = languages?.find(
				(lang) => lang.consumerLocaleId === languageFrom
			);
			setLanguageFromLocaleId(language?.lioLocaleId);
			setIsTextBeforeRtl(isRtl(language?.lioLocaleId));
		}
	}, [languageFrom]);

	const swapLanguages = () => {
		if (!languageTo) {
			return;
		}
		const from = languageFrom;
		const to = languageTo;
		const fromLocaleId = languageFromLocaleId;
		const toLocaleId = languageToLocaleId;
		setLanguageFrom(to);
		setLanguageTo(from);
		setLanguageFromLocaleId(toLocaleId);
		setLanguageToLocaleId(fromLocaleId);
		setIsTextBeforeRtl(isRtl(toLocaleId));
		setIsTextAfterRtl(isRtl(fromLocaleId));
	};

	const getLocale = (locale: string) => {
		return languages?.find(
			(lang) => lang.consumerLocaleId === locale
		);
	};

	const handleFromSelect = (event:any) => {
		setLanguageFrom(event.target.value);
		const locale = getLocale(event.target.value);
		setLanguageFromLocaleId(locale?.lioLocaleId);
		setIsTextBeforeRtl(isRtl(locale?.lioLocaleId));

	};

	const handleIntoSelect = (event: any) => {
		setLanguageTo(event.target.value);
		const locale = getLocale(event.target.value);
		setLanguageToLocaleId(locale?.lioLocaleId);
		setIsTextAfterRtl(isRtl(locale?.lioLocaleId));
	};

	return (
		<Stack className="mt-2 gap-1 " direction="horizontal">
			 <LanguageFormSelect
				title={languageFrom !== '' ? 'Detected' : 'From'}
				subTitle={'Detect Language'}
				languages={languages}
				value={languageFrom}
				onChange={handleFromSelect}
				isLoading={isSourceLocaleLoading}
			/>

			<div>
				{swappable ? (
					<span tabIndex={0} data-toggle="tooltip" title={'Swap Languages'}>
						<ArrowLeftRight
							className="mx-2 text-brand icon "
							onClick={() => swapLanguages()}
						/>
					</span>
				) : (
					<span
						tabIndex={0}
						data-toggle="tooltip"
						title={swappable ? 'Swap Languages' : 'Cannot Swap Languages'}
					>
						<ArrowRightCircleFill className="mx-2 text-brand icon" />
					</span>
				)}
			</div>

			<LanguageFormSelect
				title={'Into:'}
				subTitle={'Select a Language'}
				languages={languages}
				value={languageTo}
				onChange={handleIntoSelect}
			/>

		</Stack>
	);
};
export default TranslateSelection;
